export default __webpack_public_path__ + "static/14-970454c1f73616e5ae2bab1dd90172a6.jpg";